<div class="container">
  <div class="text">{{data.text}}</div>
</div>
